<template>
    <filters-block @toggle="$emit('toggle')" :collapse="collapse" :title="localizeList.directsUpper" :open="open">
        <div class="directs-list">
            <div v-for="(item, key) in tourTransplantationList"
                 :key="key">
                <div class="directs-item">
                    <checkbox v-model="item.isChecked" @change="changeTourTransplantation(key, $event)">
                        <span class="ellipsis" :title="localizeList[item.label]">{{localizeList[item.label]}}</span>
                    </checkbox>
                </div>
            </div>
        </div>
    </filters-block>
</template>

<script>
    import FiltersBlock from "./filtersBlock";
    export default {
        name: "directs",
        props: {
            tourTransplantationList: {
                type: Array,
                required: true
            },
            collapse: {
                type: Number,
                default: 0
            },
            open: {
                type: Number,
                default: 0
            },
        },
        components: {
            FiltersBlock
        },
        methods: {
            changeTourTransplantation(key, e) {
                this.$parent.$parent.filtersLoader = true;
                this.$parent.$parent.$parent.changeTourTransplantation(key, e);
            }
        }
    }
</script>

<style scoped>

    .directs-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 175px;
    }

    .vertical-filters .directs-list {
        max-height: 340px;
    }

    .directs-list .directs-item {
        padding: 7px 0;
        display: flex;
        align-items: center;
    }

</style>